module.exports = __webpack_public_path__ + "static/section-img2@2x-6ad102734501284cec09d7aa2d51bdfe.png";